export enum GetTrainingVideoActionDispatchTypes {
  GET_TRAINING_VIDEO_INVOKE = "GET_TRAINING_VIDEO_INVOKE",
  GET_TRAINING_VIDEO_SUCCESS = "GET_TRAINING_VIDEO_SUCCESS",
  GET_TRAINING_VIDEO_ERROR = "GET_TRAINING_VIDEO_ERROR",
  GET_TRAINING_VIDEO_RESET = "GET_TRAINING_VIDEO_RESET",
}

export enum GetGeneratedVideoUrlActionDispatchTypes {
  GET_GENERATED_VIDEO_URL_INVOKE = "GET_GENERATED_VIDEO_URL_INVOKE",
  GET_GENERATED_VIDEO_URL_SUCCESS = "GET_GENERATED_VIDEO_URL_SUCCESS",
  GET_GENERATED_VIDEO_URL_ERROR = "GET_GENERATED_VIDEO_URL_ERROR",
  GET_GENERATED_VIDEO_URL_RESET = "GET_GENERATED_VIDEO_URL_RESET",
}

export enum DeleteTrainingVideoActionDispatchTypes {
  DELETE_TRAINING_VIDEO_INVOKE = "DELETE_TRAINING_VIDEO_INVOKE",
  DELETE_TRAINING_VIDEO_SUCCESS = "DELETE_TRAINING_VIDEO_SUCCESS",
  DELETE_TRAINING_VIDEO_ERROR = "DELETE_TRAINING_VIDEO_ERROR",
  DELETE_TRAINING_VIDEO_RESET = "DELETE_TRAINING_VIDEO_RESET",
}

export const BOOKMARK_ERROR =
  "Please fill both time and description fields for each bookmark and ensure the time is valid.";

export const CONFIRM_DELETE = "Are you sure you want to delete this video?";

export const BookmarkDefaultData = {
  time: "",
  description: "",
};

export const TRAINING_PORTAL_MESSAGES = {
  welcomeMessage: "Welcome to the Training Portal",
  tangoAdminMessage:
    "Get started by adding your first training video. Click the button below to begin.",
  otherUserMessage: "Videos will be available soon! Check back later.",
};

export enum PostTrainingVideoActionDispatchTypes {
  POST_TRAINING_VIDEO_INVOKE = "POST_TRAINING_VIDEO_INVOKE",
  POST_TRAINING_VIDEO_SUCCESS = "POST_TRAINING_VIDEO_SUCCESS",
  POST_TRAINING_VIDEO_ERROR = "POST_TRAINING_VIDEO_ERROR",
  POST_TRAINING_VIDEO_RESET = "POST_TRAINING_VIDEO_URL_RESET",
}

export enum PutTrainingVideoActionDispatchTypes {
  PUT_TRAINING_VIDEO_INVOKE = "PUT_TRAINING_VIDEO_INVOKE",
  PUT_TRAINING_VIDEO_SUCCESS = "PUT_TRAINING_VIDEO_SUCCESS",
  PUT_TRAINING_VIDEO_ERROR = "PUT_TRAINING_VIDEO_ERROR",
  PUT_TRAINING_VIDEO_RESET = "PUT_TRAINING_VIDEO_URL_RESET",
}

export const defaultViewVideoTrainingData = {
  videoID: 0,
  name: "",
  title: "",
  description: "",
  bookmarks: "",
  createdBy: "",
  lastModified: "",
  url: "",
  isActive: true,
};

export const FILE_DELETED = "File Deleted";

export const defaultTrainingVideoResponse = {
  message: "",
  videoId: 0,
};
